var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOwner)?_c('div',{staticClass:"body-1"},[_vm._v("Pídele al dueño de la cuenta que actualice su plan.")]):_c('v-btn',{attrs:{"small":"","rounded":"","color":"primary"},on:{"click":_vm.onClick}},[_vm._v("Contrata un nuevo plan")])}
var staticRenderFns = []

export { render, staticRenderFns }